import type { MutableRefObject, Ref, RefCallback } from 'react'

export function mergeRefs<T = any>(
  refs: (MutableRefObject<T> | Ref<T> | undefined | null)[]
): RefCallback<T> {
  // From https://github.com/gregberge/react-merge-refs/blob/96ca3bf1feea0e9f0a4c6d5ca247882be3cba585/src/index.tsx
  return (value) => {
    refs.forEach((ref) => {
      if (typeof ref === 'function') {
        ref(value)
      } else if (ref != null) {
        ;(ref as MutableRefObject<T | null>).current = value
      }
    })
  }
}
